import React, { Component } from 'react';
import { Container } from 'reactstrap';
import SearchPanel from '@components/SearchPanel/SearchPanel';
import Table from './Table/Table';
import PaginationPanel from '@components/PaginationPanel/PaginationPanel';
import { Helmet } from 'react-helmet';
import * as actions from '@src/store/actions';
import connect from 'react-redux/es/connect/connect';
import DeveloperModal from './DeveloperModal/DeveloperModal';
import { withRouter } from 'react-router';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import Auth from '@src/components/Elements/Auth/Auth';

class Developers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phraze: '',
      modalActive: false
    };

    if (props.list.length === 0) {
      props.getList({}, true);
    }
  }

  componentDidMount = () => {
    document.getElementsByClassName('input-search')[0].click();
    document.getElementsByClassName('input-search')[0].focus();
  };

  onEntityClick = entityId => {
    this.props.history.push(`/developers/${entityId}`);
  };

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  searchTimeout: null;

  onSearch = value => {
    clearTimeout(this.searchTimeout);
    this.setState({
      phraze: value
    });
    this.searchTimeout = setTimeout(
      () =>
        this.props.getList({
          phraze: value,
          limit: this.props.limit,
          sort: this.props.sort,
          direction: this.props.direction
        }),
      1000
    );
  };

  render = () => {
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | Developers</title>
        </Helmet>
        <div className={this.props.loaded ? 'position-relative' : 'd-none'}>
          {this.props.loading && (
            <ProgressBox text={'Loading ...'} loader={'blue-background'} />
          )}
          <h3>Developers</h3>
          <SearchPanel
            showFilter={false}
            createBtn={false}
            searchValue={this.state.phraze}
            onSearchChange={phraze => this.onSearch(phraze)}
            searchPlaceholder={'Search by Developer’s name'}
          >
            <Auth action={'Developers::edit'}>
              <button
                className={'btn btn-primary px-3'}
                onClick={() => this.toggle('modalActive')}
              >
                Create New Developer
              </button>
            </Auth>
          </SearchPanel>
          <Table
            entities={this.props.list}
            onEntityClick={entityId => this.onEntityClick(entityId)}
            {...this.props}
            paginationFunc={this.props.getList}
            phraze={this.state.phraze}
          />
          <PaginationPanel
            {...this.props}
            paginationFunc={this.props.getList}
            phraze={this.state.phraze}
          />
          <DeveloperModal
            entity={{}}
            history={this.props.history}
            isActive={this.state.modalActive}
            toggle={() => this.toggle('modalActive')}
          />
        </div>
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    list: state.developer.list,
    page: state.developer.page,
    limit: state.developer.limit,
    total: state.developer.total,
    start: state.developer.start,
    end: state.developer.end,
    sort: state.developer.sort,
    loaded: state.developer.loaded,
    direction: state.developer.direction,
    loading: state.developer.loading
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getList: (getData, hideLoader) =>
      dispatch(actions.getDevelopersList(getData, hideLoader))
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Developers)
);
